import script from "./grounpNotice.vue?vue&type=script&setup=true&name=GrounpNotice&lang=js"
export * from "./grounpNotice.vue?vue&type=script&setup=true&name=GrounpNotice&lang=js"

import "./grounpNotice.vue?vue&type=style&index=0&id=a28aba7a&scoped=true&lang=css"
import "./grounpNotice.vue?vue&type=style&index=1&id=a28aba7a&lang=css"

import exportComponent from "/Users/nasinet/hujing_pro/hj_pro_h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a28aba7a"]])

export default __exports__